import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
    name: 'customDate',
    standalone: false
})
export class CustomDatePipe implements PipeTransform {

  transform(value: string): string {
    const date = new Date(value);
    if (isNaN(date.getTime())) {
      return value; // return the original value if the date is invalid
    }

    const datePipe = new DatePipe('en-US');
    return datePipe.transform(date, 'd MMMM, y');
  }

}
